// FETCH ALL PROCESS
export const FETCH_PROCESS_REQUEST_DK = 'FETCH_PROCESS_REQUEST_DK';
export const FETCH_PROCESS_SUCCESS_DK = 'FETCH_PROCESS_SUCCESS_DK';
export const FETCH_PROCESS_FAILURE_DK = 'FETCH_PROCESS_FAILURE_DK';

// CREATE PROCESS
export const CREATE_PROCESS_REQUEST_DK = 'CREATE_PROCESS_REQUEST_DK';
export const CREATE_PROCESS_SUCCESS_DK = 'CREATE_PROCESS_SUCCESS_DK';
export const CREATE_PROCESS_FAILURE_DK = 'CREATE_PROCESS_FAILURE_DK';

// UPDATE PROCESS
export const UPDATE_PROCESS_REQUEST_DK = 'UPDATE_PROCESS_REQUEST_DK';
export const UPDATE_PROCESS_SUCCESS_DK = 'UPDATE_PROCESS_SUCCESS_DK';
export const UPDATE_PROCESS_FAILURE_DK = 'UPDATE_PROCESS_FAILURE_DK';

// FETCH SINGLE STATE OF PROCESS
export const FETCH_SINGLE_PROCESS_REQUEST_DK = 'FETCH_SINGLE_PROCESS_REQUEST_DK';
export const FETCH_SINGLE_PROCESS_SUCCESS_DK = 'FETCH_SINGLE_PROCESS_SUCCESS_DK';
export const FETCH_SINGLE_PROCESS_FAILURE_DK = 'FETCH_SINGLE_PROCESS_FAILURE_DK';

// DELETE PROCESS
export const DELETE_PROCESS_REQUEST_DK = 'DELETE_PROCESS_REQUEST_DK';
export const DELETE_PROCESS_SUCCESS_DK = 'DELETE_PROCESS_SUCCESS_DK';
export const DELETE_PROCESS_FAILURE_DK = 'DELETE_PROCESS_FAILURE_DK';

// CREATE_ASSIGN PROCESS
export const CREATE_ASSIGN_PROCESS_REQUEST_DK = 'CREATE_ASSIGN_PROCESS_REQUEST_DK';
export const CREATE_ASSIGN_PROCESS_SUCCESS_DK = 'CREATE_ASSIGN_PROCESS_SUCCESS_DK';
export const CREATE_ASSIGN_PROCESS_FAILURE_DK = 'CREATE_ASSIGN_PROCESS_FAILURE_DK';

// FETCH ALL ASSIGN PROCESS
export const FETCH_ASSIGN_PROCESS_REQUEST_DK = 'FETCH_ASSIGN_PROCESS_REQUEST_DK';
export const FETCH_ASSIGN_PROCESS_SUCCESS_DK = 'FETCH_ASSIGN_PROCESS_SUCCESS_DK';
export const FETCH_ASSIGN_PROCESS_FAILURE_DK = 'FETCH_ASSIGN_PROCESS_FAILURE_DK';

// DELETE PROCESS
export const DELETE_ASSIGN_PROCESS_REQUEST_DK = 'DELETE_ASSIGN_PROCESS_REQUEST_DK';
export const DELETE_ASSIGN_PROCESS_SUCCESS_DK = 'DELETE_ASSIGN_PROCESS_SUCCESS_DK';
export const DELETE_ASSIGN_PROCESS_FAILURE_DK = 'DELETE_ASSIGN_PROCESS_FAILURE_DK';

// UPDATE ASSIGN_PROCESS
export const UPDATE_ASSIGN_PROCESS_REQUEST_DK = 'UPDATE_ASSIGN_PROCESS_REQUEST_DK';
export const UPDATE_ASSIGN_PROCESS_SUCCESS_DK = 'UPDATE_ASSIGN_PROCESS_SUCCESS_DK';
export const UPDATE_ASSIGN_PROCESS_FAILURE_DK = 'UPDATE_ASSIGN_PROCESS_FAILURE_DK';

// FETCH SINGLE STATE OF ASSIGN_PROCESS
export const FETCH_SINGLE_ASSIGN_PROCESS_REQUEST_DK = 'FETCH_SINGLE_ASSIGN_PROCESS_REQUEST_DK';
export const FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS_DK = 'FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS_DK';
export const FETCH_SINGLE_ASSIGN_PROCESS_FAILURE_DK = 'FETCH_SINGLE_ASSIGN_PROCESS_FAILURE_DK';

// FETCH ALL ASSIGN PROCESS BY STYLE ID
export const FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST_DK = 'FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST_DK';
export const FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS_DK = 'FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS_DK';
export const FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE_DK = 'FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE_DK';

// FETCH ALL ASSIGN PROCESS BY STYLE ID
export const FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST_DK = 'FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST_DK';
export const FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS_DK = 'FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS_DK';
export const FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE_DK = 'FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE_DK';

export const RESET_PROCESS_INFO_DK = 'RESET_PROCESS_INFO_DK';

export const RESET_ASSIGN_PROCESS_INFO_DK = 'RESET_ASSIGN_PROCESS_INFO_DK';

export const CREATE_PROCESS_FORM_DK = 'CREATE_PROCESS_FORM_DK';
export const CREATE_ASSIGN_PROCESS_FORM_DK = 'CREATE_ASSIGN_PROCESS_FORM_DK';

export const UPDATE_PROCESS_FORM_DK = 'UPDATE_PROCESS_FORM_DK';
export const UPDATE_ASSIGN_PROCESS_FORM_DK = 'UPDATE_ASSIGN_PROCESS_FORM_DK';

// NAVIGATE TO PROCESS DETAILS COMPONENT
export const NAVIGATE_PROCESS_DETAILS_DK = 'NAVIGATE_PROCESS_DETAILS_DK';

// NAVIGATE TO PROCESS COMPONENT
export const NAVIGATE_PROCESS_DK = 'NAVIGATE_PROCESS_DK';
